import script from "./TransitionProjectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TransitionProjectModal.vue?vue&type=script&setup=true&lang=js"

import "./TransitionProjectModal.vue?vue&type=style&index=0&id=0677a542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0677a542"]])

export default __exports__